import React from "react";
import '../../style/circleLoader.css'
import { CIRCLE } from "../../helpers/constants";
import { Loader, Slider } from "arag-ui-lib";
import BASE_URL from "../../cycles/variables";

const SolicitorHomeSlider = (props) => {

    const {
        imageCounter,
        fetchedImageIndexes,
        fetchingImages,
        images,
        incrementImageCounter,
    } = props;
    const src = BASE_URL + 'images/';
    return (
        <div>
            {
                imageCounter !== fetchedImageIndexes.length || fetchingImages
                ?
                    <div style={{display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
                        <Loader variant={CIRCLE} />
                    </div>
                :
                    null
            }
            {
                images.length > 0 
                ?
                    <Slider
                        items={images}
                        settings={{
                            dots: false,
                            infinite: true,
                            speed: 1500,
                            slidesToShow: 1,
                            arrows: false,
                            autoplay: true,
                            autoplaySpeed: 5000,
                            fade:true,
                            adaptiveHeight: true,
                            swipeToSlide: false,
                            swipe: false,
                            className: 'sliderReactStyle',
                            lazyLoad: true
                        }}
                        onLoad={incrementImageCounter}
                        sliderTestId={"solicitor-home-slideshow"}
                        src={src}
                    />
                :
                    null
            }
        </div>

    );
};

export default SolicitorHomeSlider;



